import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircleIcon } from 'lucide-react';
const items = [{
  resource: 'Gato Zen',
  description: 'El protocolo completo para eliminar los maullidos nocturnos en 7 días',
  value: 'Principal'
}, {
  resource: 'Kit de Emergencia 3 AM',
  description: 'Qué hacer exactamente cuando tu gato te despierta de madrugada',
  value: 'Incluido'
}, {
  resource: 'Rutina Nocturna Express',
  description: 'La secuencia de 20 minutos para preparar a tu gato antes de dormir',
  value: 'Incluido'
}];
export function ValueSummary() {
  return <section className="py-10 sm:py-14 bg-navy-light/30 border-y border-white/5" data-id="element-343">
      <div className="mx-auto max-w-5xl px-6 lg:px-8" data-id="element-344">
        <FadeIn data-id="element-345">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8" data-id="element-346">
            Lo que recibís hoy
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-347">
          <div className="bg-navy-light border border-white/10 rounded-2xl overflow-hidden" data-id="element-348">
            {/* Table Header - Hidden on mobile */}
            <div className="hidden md:grid md:grid-cols-12 gap-4 bg-navy border-b border-white/10 px-6 py-4 font-bold text-sm text-slate-400" data-id="element-349">
              <div className="col-span-3" data-id="element-350">Recurso</div>
              <div className="col-span-7" data-id="element-351">Descripción</div>
              <div className="col-span-2 text-right" data-id="element-352">Valor</div>
            </div>

            {/* Table Rows */}
            <div className="divide-y divide-white/5" data-id="element-353">
              {items.map((item, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-6 py-5 hover:bg-white/5 transition-colors" data-id="element-354">
                  <div className="md:col-span-3 flex items-center gap-2" data-id="element-355">
                    <CheckCircleIcon className="h-5 w-5 text-gold shrink-0" data-id="element-356" />
                    <span className="font-bold text-slate-100" data-id="element-357">
                      {item.resource}
                    </span>
                  </div>
                  <div className="md:col-span-7 text-slate-400 font-sans text-sm md:text-base" data-id="element-358">
                    {item.description}
                  </div>
                  <div className="md:col-span-2 md:text-right" data-id="element-359">
                    <span className="inline-block bg-gold/10 text-gold px-3 py-1 rounded-full text-sm font-medium" data-id="element-360">
                      {item.value}
                    </span>
                  </div>
                </div>)}
            </div>

            {/* Total */}
            <div className="bg-gold/5 border-t-2 border-gold/30 px-6 py-6" data-id="element-361">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-362">
                <span className="text-lg font-bold text-slate-100" data-id="element-363">
                  Todo esto por
                </span>
                <div className="flex items-baseline gap-2" data-id="element-364">
                  <span className="text-4xl font-bold text-gold-light" data-id="element-365">
                    $9.499
                  </span>
                  <span className="text-xl text-slate-400" data-id="element-366">ARS</span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-4 text-sm text-slate-400" data-id="element-367">
                <span data-id="element-368">Acceso inmediato</span>
                <span className="hidden sm:block" data-id="element-369">•</span>
                <span data-id="element-370">Entrega directa a tu email</span>
                <span className="hidden sm:block" data-id="element-371">•</span>
                <span data-id="element-372">Sin espera</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}